<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-chip
        :close="!!formattedDateInverval"
        :disabled="!!value.saving"
        v-on="on"
        @click:close="clearDates()"
      >
        <v-icon left>
          event
        </v-icon>

        <span v-if="formattedDateInverval">{{ formattedDateInverval }}</span>
        <em
          v-else
          v-t="'activities.noDates'"
        />
      </v-chip>
    </template>

    <v-date-picker
      v-model="dates"
      range
      :title-date-format="datePickerTitle"
    >
      <v-spacer />

      <v-btn
        v-t="'cancel'"
        text
        color="primary"
        @click="menu = false"
      />

      <v-btn
        text
        color="primary"
        @click="setActivityDates()"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import Activity from '@/models/Activity'
import { fmtDatesInterval } from '@/filters'

export default {
  props: {
    value: {
      type: Activity,
      default: () => new Activity()
    }
  },
  data () {
    return {
      activity: null,
      dates: [],
      menu: false
    }
  },
  computed: {
    formattedDateInverval () {
      return fmtDatesInterval(this.value.$.startDate, this.value.$.dueDate)
    }
  },
  watch: {
    menu (open) {
      if (open) {
        this.dates = []

        if (this.value.startDate) {
          this.dates.push(this.value.startDate)
        }

        if (this.value.dueDate) {
          this.dates.push(this.value.dueDate)
        }
      }
    }
  },
  methods: {
    setActivityDates () {
      const sorted = [ ...this.dates ].sort()

      if (sorted.length === 2) {
        this.value.startDate = sorted[0]
        this.value.dueDate = sorted[1]
        this.value.save()
      } else if (sorted.length === 1) {
        this.value.startDate = null
        this.value.dueDate = sorted[0]
        this.value.save()
      }

      this.menu = false
    },
    datePickerTitle (dates) {
      const sorted = [ ...dates ].sort()
      return fmtDatesInterval(sorted[0], sorted[1])
    },
    clearDates () {
      this.value.startDate = null
      this.value.dueDate = null
      this.value.save()
    }
  }
}
</script>
